<!--------New design of Edit profile------->
<ngx-spinner  bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-scale-multiple"
[fullScreen]="true" [showSpinner]="true"> </ngx-spinner>
<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a>Clients:</a></li>
    <li class="active"><a>Add Client</a></li>
  </ul>
  <div class="right">
    <!-- <span>{{today}}</span> -->
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>


<div class="Content_outer">
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="newform_outer">
          <div class="filter_div">
            <div class="top">
              <h4>{{showEditUsertxt}}</h4>
            </div>
          </div>
          <div class="both_side edit_profile">
            <div class="left_side">
              <h4>Company Logo</h4>
              <div class="inner">
                <div class="upload">
                  <img src="{{_companyLogo}}" class="companyLogo" alt="User" onerror="this.src='./assets/img-new/default_user.png'">
                  <div class="action_btn">
                    <div class="upload-btn-wrapper" *ngIf="showEditUsertxt === 'Create Client'">
                      <button class="btn default_btn" mat-raised-button (click)="uploadClick.click()">Upload Logo</button>
                      <input #uploadClick type="file" name="myfile" ng2FileSelect [uploader]="companyUploader"
                        (change)="upload($event.target.files,'companyLogo')"  />
                    </div>
                    <div class="upload-btn-wrapper" *ngIf="showEditUsertxt === 'Edit Client'">
                      <button class="btn default_btn" mat-raised-button (click)="fileInput.click()">Replace</button>
                      <input  #fileInput type="file" name="myfile" ng2FileSelect [uploader]="companyUploader"
                        (change)="upload($event.target.files,'companyLogo')" />
                    </div>
                    <button *ngIf="showEditUsertxt === 'Edit Client'" class="btn default_btn" mat-raised-button
                      (click)="removeUserImage('companyLogo')">Remove</button>
                  </div>
                  <div class="support">
                    <h5>Supported formats:<span>jpg, png, gif</span></h5>
                    <h5>Maximum Size:<span>500KB</span></h5>
                  </div>
                </div>
                <h4>Client Picture</h4>
                <div class="upload">
                  <img src="{{_imgUrl}}" alt="User" onerror="this.src='./assets/img-new/default_user.png'">
                  <div class="action_btn">
                    <div class="upload-btn-wrapper" *ngIf="showEditUsertxt === 'Create Client'">
                      <button class="btn default_btn" mat-raised-button (click)="fileUpload.click()">Upload Picture</button>
                      <input #fileUpload type="file" name="myfile" ng2FileSelect [uploader]="uploader"
                        (change)="upload($event.target.files,'clientPicture')" />
                    </div>
                    <div class="upload-btn-wrapper" *ngIf="showEditUsertxt === 'Edit Client'">
                      <button class="btn default_btn" mat-raised-button (click)="fileInput.click()">Replace</button>
                      <input #fileInput type="file" name="myfile" ng2FileSelect [uploader]="uploader"
                        (change)="upload($event.target.files, 'clientPicture')" />
                    </div>
                    <button *ngIf="showEditUsertxt === 'Edit Client'" class="btn default_btn" mat-raised-button
                      (click)="removeUserImage('clientPicture')">Remove</button>
                  </div>
                  <div class="support">
                    <h5>Supported formats:<span>jpg, png, gif</span></h5>
                    <h5>Maximum Size:<span>500KB</span></h5>
                  </div>
                </div>

              </div>
            </div>
            <form [formGroup]="uForm" (ngSubmit)="saveUser()">
              <div class="right_side">
                <ul  ngbNav #ctdTabset="ngbNav" class="nav nav-tabs custom_tab" [(activeId)]="tabActive" (navChange)="onTabChange($event)">
                  <li  [ngbNavItem]="'tab1'">
                    <a  ngbNavLink>Client Details</a>
                      <ng-template class="right_side" ngbNavContent>
                        <div class="row" style="padding-top: 20px;">
                          <div class="col col-md-6">
                            <label>Company Name *</label>
                            <input type="text" class="form-control" formControlName="company_name" id="company_name">
                            <control-messages class="err-msg" [control]="uForm.controls.company_name"></control-messages>
                          </div>
                          <div class="col col-md-6">
                            <label>Industry Type *</label>
                            <span class="custom_select_outer">
                              <select class="custom_select form-control" formControlName="industry_type" id="industry_type"
                                (change)="selectedIndustryType($event.target.value)">
                                <option *ngFor="let industry of industryType" [(value)]="industry.title">{{industry.title}}
                                </option>
                              </select>
                              <control-messages class="err-msg" [control]="uForm.controls.industry_type"></control-messages>
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col col-md-6">
                            <label>Client Name *</label>
                            <input type="text" class="form-control" formControlName="full_name" id="full_name">
                            <control-messages class="err-msg" [control]="uForm.controls.full_name"></control-messages>
                          </div>
                          <div class="col col-md-6">
                            <label>Email Address *</label>
                            <input type="text" class="form-control" formControlName="email" id="email">
                            <control-messages class="err-msg" [control]="uForm.controls.email"></control-messages>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col col-md-6">
                            <label>Phone Number *</label>
                            <ngx-intl-tel-input
                            [cssClass]="'form-control phone-input'"
                             [preferredCountries]="['in', 'us','ca']"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="['name', 'dialCode', 'iso2']"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="''"
                            formControlName="phone_number" id="phone_number"
                            (ngModelChange)="onCountryChange($event)"
                            [phoneValidation]="true"
                          ></ngx-intl-tel-input>
                          </div>
                        </div>
                        <control-messages class="err-msg" [control]="uForm.controls['phone_number']"></control-messages>

                        <hr class="horizontal_line">
                        <div class="row">
                          <div class="col col-md-6">
                            <label>Address Line 1 *</label>
                            <input type="text" class="form-control" formControlName="address_line1" id="address_line1">
                            <control-messages class="err-msg" [control]="uForm.controls.address_line1"></control-messages>
                          </div>
                          <div class="col col-md-6">
                            <label>Address Line 2</label>
                            <input type="text" class="form-control" formControlName="address_line2" id="address_line2">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col col-md-6">
                            <div class="row">
                              <div class="col col-md-6">
                                <label>Country *</label>
                                <span class="custom_select_outer">
                                  <select class="custom_select form-control" formControlName="country_name_" id="country_name_"
                                    (ngModelChange)="onChange($event)">
                                    <option *ngFor="let countrys of countryNames" [value]="countrys.country">
                                      {{countrys.country}}</option>
                                  </select>
                                  <control-messages class="err-msg" [control]="uForm.controls.country_name_"></control-messages>
                                </span>
                              </div>
                              <div class="col col-md-6">
                                <label>State/Province*</label>
                                <span class="custom_select_outer">
                                  <select class="custom_select form-control" formControlName="state_name">
                                    <option></option>
                                    <option *ngFor="let state of states" (click)="selectedState(state)" [value]="state">
                                      {{state}}</option>
                                  </select>
                                  <control-messages class="err-msg" [control]="uForm.controls.state_name"></control-messages>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col col-md-6">
                            <div class="row">
                              <div class="col col-md-6">
                                <label>City *</label>
                                <input type="text" class="form-control" (ngModelChange)="onChangeCity($event)" formControlName="city_name" id="city_name">
                                <control-messages class="err-msg" [control]="uForm.controls.city_name"></control-messages>
                                <span *ngIf="errorchecker" class="errormessage"> {{errormessage}}</span>
                              </div>
                              <div class="col col-md-6">
                                <label>Postal Code *</label>
                                <input type="text" class="form-control" formControlName="postcode" id="postcode">
                                <control-messages class="err-msg" [control]="uForm.controls.postcode"></control-messages>
                                <span *ngIf="errorchecker" class="errormessage"> {{errormessagepostel}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col col-md-6">
                            <div class="row">
                              <div class="col col-md-6">
                                <label>TimeZone *</label>
                                <span class="custom_select_outer">
                                  <select class="custom_select form-control" formControlName="timezone">
                                    <option *ngFor="let timezone of timeZones" [value]="timezone"> {{timezone}}</option>
                                  </select>
                                  <control-messages class="err-msg" [control]="uForm.controls.timezone"></control-messages>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <hr class="horizontal_line">
                          <h4>OEM</h4>
                          <div class="OEM-checkbox" formArrayName="OEMCheckBox">
                            <li *ngFor="let item of OEMCheckBox.controls; let i = index">
                              <input type="checkbox" [formControlName]="i"><label style="width: 130px; margin-left:-20px" for="">{{checkBoxList[i].value}}</label>
                            </li>
                          </div>
                        </div>
                      </ng-template>
                    </li>
                  <li [ngbNavItem]="'tab2'" >
                    <a a ngbNavLink>Product & Subscriptions</a>
                      <ng-template class="row" ngbNavContent>
                        <div style="padding-top: 20px;">
                          <div style="padding-top: 20px;">
                            <!-- <hr class="horizontal_line"> -->
                            <h4>Master Product Type</h4>
                            <div class="product-checkbox" formArrayName="MasterProductCheckBox">
                              <ul class="checkbox-container" *ngIf="MasterProductCheckBox.length" style="flex-direction:column;">
                                <li *ngFor="let item of MasterProductCheckBox.controls; let i = index" class="checkbox-item"
                                  style="width:auto !important;">
                                  <input type="checkbox" [formControlName]="i" (click)="onMasterProductChange($event, master_products[i].id)">
                                  <label>{{master_products[i].name}}</label>

                                </li>
                              </ul>
                            </div>
                          </div>
                          <hr class="horizontal_line">
                          <h4>Asset Type</h4>
                          <div class="product-checkbox" formArrayName="ProductCheckBox">
                            <ul class="checkbox-container">
                            <li *ngFor="let item of ProductCheckBox.controls; let i = index" class="checkbox-item">
                              <input type="checkbox" [formControlName]="i" [checked]="false" (change)="onCheckboxChange($event, productBoxList[i].id)">
                              <label>{{productBoxList[i].name}}</label>

                            </li> </ul>
                          </div>
                        </div>
                        <hr class="horizontal_line">
                        <div style="display: flex; justify-content: space-between;">
                          <h4>Software</h4>
                          @if (subscriptionStatus) {
                            <div class="status-badge" [ngClass]="subscriptionStatus?.toLowerCase()">{{ subscriptionStatus }}</div>
                          }
                        </div>
                        @if (client_master_products.length) {
                          <!-- <div formGroupName="softwareCheckboxes">
                           <ul class="checkbox-container w-100">
                             @for (item of software_types; track item.key) {
                            <li class="checkbox-item">
                                    <input type="checkbox" formControlName="{{item.key}}" (change)="onAdvancedCheckboxChange($event, item.key)">
                                    <label>
                                      {{item.name}}
                                    </label>
                              </li>
                            }
                           </ul>
                        </div> -->
                          <div class="product-checkbox">
                            <ul class="checkbox-container" style="flex-direction: column;">

                              <ng-container *ngFor="let parent of SoftwareCheckboxesV2">
                                <li
                                    [formGroup]="parent"
                                    class="center-flex-col">

                                  <label style="display:flex; cursor:pointer">
                                    <input type="checkbox"
                                          formControlName="checked"
                                          (change)="onParentSoftwareCheckboxChange($event,parent.value)" />
                                    {{ parent.value.name }}
                                  </label>

                                  <ul class="ml-20">
                                    <ng-container *ngFor="let child of parent.get('children').controls">
                                      <li
                                          [formGroup]="child"
                                          style="margin-bottom: 5px;">
                                        <label style="display:flex; cursor:pointer">
                                          <input type="checkbox"
                                                formControlName="checked"
                                                (change)="onSoftwareCheckboxV2(child.value)" />
                                          {{ child.value.name }}
                                        </label>
                                      </li>
                                    </ng-container>
                                  </ul>

                                </li>
                              </ng-container>

                            </ul>
                          </div>

                        }
                          @else {
                          <div class="err_msg center-flex">Select atleast 1 Master Product Type</div>
                        }
                        <div>
                          <hr class="horizontal_line">
                          <h4>Subscription Type</h4>
                          <div class="product-checkbox" formArrayName="SubscriptionCheckBox">
                            <ul class="checkbox-container">
                              <li *ngFor="let item of SubscriptionCheckBox; let i = index" class="checkbox-item">
                                <input type="checkbox" [formControlName]="i" (change)="onSubscriptionCheckboxChange($event, i)">
                                <label>{{ subscriptionTypes[i] }}</label>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div style="padding-top: 20px;">
                          <!-- <hr class="horizontal_line"> -->
                          <h4>Alert Subscription Type</h4>
                          <div class="product-checkbox" formArrayName="alert_subscription">
                            <ul class="checkbox-container" *ngIf="alertSubscriptionCheckboxes.length && alertSubscriptionNames.length">
                              <li class="checkbox-item"
                                style="width:auto !important;">
                                <input type="checkbox" disabled checked>
                                <label>Vibration</label>
                              </li>
                              <li *ngFor="let item of alertSubscriptionCheckboxes; let i = index" class="checkbox-item"
                                style="width:auto !important;">
                                <input type="checkbox" [formControlName]="i">
                                <label>{{alertSubscriptionNames[i]}}</label>
                              </li>
                            </ul>

                          </div>
                          </div>
                        <div style="padding-top: 20px;">
                          <!-- <hr class="horizontal_line"> -->
                          <h4>Summary Report Subscription Type</h4>
                          <div class="product-checkbox" formArrayName="reportSubscription">
                            <ul class="checkbox-container" *ngIf="reportSubscriptionCheckboxes.length">
                              <li *ngFor="let item of reportSubscriptionCheckboxes; let i = index" class="checkbox-item"
                                style="width:auto !important;">
                                <input type="checkbox" [formControlName]="i">
                                <label>{{reportSubscriptionRoles[i]?.role}}</label>
                              </li>
                            </ul>

                          </div>
                          </div>
                          <!-- <div style="padding-top: 20px;">
                            <h4>Report Subscriptions</h4>
                            <ul>
                              <li *ngFor="let item of reportSubscriptionRoles; let i = index" class="checkbox-item" style="width:auto !important;">
                                <ng-container *ngIf="item.id === 1">
                                  <input type="checkbox" disabled checked>
                                  <label>CLIENT ADMIN</label>
                                </ng-container>
                                <ng-container *ngIf="item.id === 2">
                                  <input type="checkbox">
                                  <label>CLIENT USER</label>
                                </ng-container>
                              </li>
                            </ul>
                          </div> -->

                      </ng-template>
                    </li>
                      <li [ngbNavItem]="'tab3'">
                      <a ngbNavLink>Tabs & Views</a>
                      <ng-template ngbNavContent>
                        <div class="custom-inner-tabs">
                          <!-- Inner Tab Headers -->
                          <div class="inner-tab-headers">
                            <div
                              class="inner-tab-header"
                              *ngFor="let tab of innerTabs; let i = index"
                              [ngClass]="{'active': activeInnerTab === i}"
                              (click)="activeInnerTab = i">
                              {{ tab.title }}
                            </div>
                          </div>
                          @if (client_master_products.length) {
                            <br>
                            <br>
                            <div class="product-checkbox">
                              <ul class="checkbox-container" style="flex-direction: column;">
                                <li *ngFor="let parent of SoftwareCheckboxesV2" [formGroup]="parent" class="center-flex-col">
                                  <label class="d-flex">
                                    <!-- <input type="checkbox" formControlName="checked" (change)="onParentSoftwareCheckboxChange(parent.value)"/> -->
                                    <input type="checkbox" formControlName="checked"  [disabled]="true"/>
                                    {{ parent.value.name }}
                                  </label>

                                  <ul class="ml-20">
                                    <li *ngFor="let child of parent.get('children').controls" [formGroup]="child" style="margin-bottom: 5px;">
                                      <label style="display:flex;">
                                        <input type="checkbox" formControlName="checked" [disabled]="true"/>
                                        {{ child.value.name }}
                                      </label>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>
                          }
                          </div>
                      </ng-template>
                    </li>



                <li  [ngbNavItem]="'tab4'" >
                  <a ngbNavLink>License & Management</a>
                  <ng-template  ngbNavContent>
                    <div class="license_right">
                      <span *ngIf="this.showEditUsertxt !== 'Create Client'">
                        <!-- <hr class="horizontal_line"> -->
                        <div class="sub_title_flex" style="padding-top: 20px;">
                          <label class="sub_title">License Type</label>
                          <a class="link_btn" (click)="addDeviceType()">Add Device Type</a>
                        </div>
                        <div class="row">
                          <div class="col col-md-6" *ngFor="let lic of licenceTypeArray; let inx = index;">
                            <div class="checkflex_field">
                              <div class="custom_checkbox">
                                <input [disabled]="lic.left_quantity === 0" type="checkbox" (keyup)="onKeyUp($event)"
                                  id="{{lic.id}}"
                                  (change)="checkValue($event.target, inx,lic.quantity, lic.left_quantity, lic.device_type, lic.device_type_id)">
                                <label for="{{lic.id}}"></label>
                              </div>
                              <div class="check_right">
                                <label>{{lic.device_type}}</label>
                                <input type="text" id="license_number_{{inx}}" [value]="lic.number_of_licence"
                                  class="form-control" placeholder="Enter number of licenses">
                                <div class="avail_license">Available licenses:<span class="m_l_5">{{lic.quantity}}</span>
                                </div>
                                <div class="avail_license">Left licenses:<span class="m_l_5">{{lic.left_quantity}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </span>
                      <hr class="horizontal_line">
                      <div class="row">
                        <div class="col col-md-6">
                          <label>Account Manager</label>
                          <span class="custom_select_outer">
                            <select class="custom_select form-control" formControlName="account_manager" id="account_manager">
                              <option></option>
                              <option *ngFor="let c_list of managerList" [value]="c_list.id"> {{c_list.full_name}}</option>
                            </select>
                          </span>
                        </div>
                        <div class="col col-md-6">
                          <label>Site Incharge</label>
                          <span class="custom_select_outer">
                            <select class="custom_select form-control" formControlName="site_incharge" id="site_incharge">
                              <option></option>
                              <option *ngFor="let c_list of siteInchargeList" [value]="c_list.id"> {{c_list.full_name}}</option>
                            </select>
                          </span>
                        </div>
                      </div>
                    </div>

                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="ctdTabset"></div>
                <hr class="horizontal_line">
                <div class="form_actions text-right">
                  <button *ngIf="showSavebtn" mat-raised-button color="primary" type="submit"
                    [disabled]="!uForm.valid"><span>Create Client</span></button>
                  <button *ngIf="showUpdateBtn && tabActive != 'tab3'" color="primary" mat-raised-button type="submit"
                    [disabled]="!(uForm.valid && uForm.dirty)"><span>Update</span></button>
                  <!-- <button *ngIf="showUpdateBtn && tabActive == 'tab3'" color="primary" mat-raised-button type="submit"
                    [disabled]="false" (click)="saveChanges()"><span>Update</span></button> -->
                  <button color="warn" mat-stroked-button (click)="openListPage()" type="button"><span>Cancel</span></button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!------------------------>
